import { memo } from "react";
import toast from "react-hot-toast";
import { FormControl, Select, MenuItem } from "@mui/material";
import { supabase } from "../../../../../supabase";
import { useMainContext } from "../../../../../context/useMainContext";

const AssignedMemberCell = ({ row, col }) => {
  const { setRows, availableUsers, isGuest } = useMainContext();
  let currentUserSelected;
  let currentValue;
  if (row[col]) {
    currentUserSelected = availableUsers.find((user) => user.name === row[col] || user.db_name === row[col]);
    currentValue = currentUserSelected?.db_name || currentUserSelected?.name;
  }
  
  const handleAssignedMemberChange = async (e) => {
    const newAssignedMember = e.target.value;
    try {
      const { error } = await supabase
        .from("influencers")
        .update({
          assigned_member: newAssignedMember,
        })
        .eq("id", row.id);

      if (error) {
        console.error("Supabase error updating assigned member:", error);
        toast.error("Failed to update assigned member.");
      } else {
        setRows((prevRows) =>
          prevRows.map((r) =>
            r.id === row.id
              ? {
                  ...r,
                  assigned_member: newAssignedMember,
                }
              : r
          )
        );
        toast.success("Assigned member updated!");
      }
    } catch (err) {
      console.error("Error updating assigned member:", err);
      toast.error("Failed to update assigned member.");
    }
  };

  return (
    <FormControl size="small" variant="outlined">
      <Select
        value={currentValue || ""}
        onChange={handleAssignedMemberChange}
        displayEmpty
        sx={{
          bgcolor: currentValue ? "transparent" : "action.selected",
        }}
        disabled={isGuest}
      >
        <MenuItem value="" disabled>
          Assign member
        </MenuItem>
        {availableUsers.map((user) => {
          const value = user?.db_name || user.name;
          return (
            <MenuItem key={user.id} value={value}>
              {value}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  );
};

export default memo(AssignedMemberCell);
